import '.ad{background-color:white;}.ssr-plugin'
import '.a8{border-radius:12px;}.ssr-plugin'
import '.ae{box-shadow:0 2px 8px rgba(0, 0, 0, 0.1);}.ssr-plugin'
import '.af{padding:1.5rem;}.ssr-plugin'
import '.ag{transition:transform 0.2s, box-shadow 0.2s;}.ssr-plugin'
import '.ah{cursor:pointer;}.ssr-plugin'
import '.ai{font-size:1.25rem;}.ssr-plugin'
import '.aj{font-weight:600;}.ssr-plugin'
import '.ak{margin-bottom:0.5rem;}.ssr-plugin'
import '.al{color:#333;}.ssr-plugin'
import '.am{font-size:1rem;}.ssr-plugin'
import '.w{color:#666;}.ssr-plugin'
import '.an{margin-bottom:0.25rem;}.ssr-plugin'
import '.ao{font-weight:500;}.ssr-plugin'
import '.ap{font-size:0.9rem;}.ssr-plugin'
import '.aq{margin-bottom:1rem;}.ssr-plugin'
import '.ar{border-top:1px solid #eee;}.ssr-plugin'
import '.as{padding-top:1rem;}.ssr-plugin'
import '.at{font-size:0.875rem;}.ssr-plugin'
import '.au{color:#999;}.ssr-plugin'
import '.av{color:#555;}.ssr-plugin'
import '.aw{line-height:1.5;}.ssr-plugin'
import '.ax{max-height:100px;}.ssr-plugin'
import '.f{overflow:hidden;}.ssr-plugin'
import '.ay{position:relative;}.ssr-plugin'
import { styled } from 'inlines'

type CardProps = {
  name: string
  song: string
  nationality: string
  lyrics: string
}

export const Card = ({ name, song, nationality, lyrics }: CardProps) => {
  return (
    <styled.div className="ad a8 ae af ag ah"
      style={{
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: '0 4px 16px rgba(0, 0, 0, 0.15)',
        },
      }}
    >
      <h3 className="ai aj ak al"
        style={{
          fontFamily: `"Inter", Arial, Helvetica, sans-serif`,}}
      >
        {name}
      </h3>
      <p className="am w an"
        style={{
          fontFamily: `"Inter", Arial, Helvetica, sans-serif`,}}
      >
        <span className="ao">Song:</span> {song}
      </p>
      <p className="ap w aq"
        style={{
          fontFamily: `"Inter", Arial, Helvetica, sans-serif`,}}
      >
        <span className="ao">Country:</span> {nationality}
      </p>
      <div className="ar as"
      >
        <p className="at au ao ak"
          style={{
            fontFamily: `"Inter", Arial, Helvetica, sans-serif`,}}
        >
          Lyrics:
        </p>
        <styled.p className="at av aw ax f ay"
          style={{
            fontFamily: `"Inter", Arial, Helvetica, sans-serif`,
            '&::after': {
              content: '""',
              position: 'absolute',
              bottom: 0,
              left: 0,
              right: 0,
              height: '30px',
              background: 'linear-gradient(transparent, white)',
            },
          }}
        >
          {lyrics}
        </styled.p>
      </div>
    </styled.div>
  )
}